module.exports = __webpack_public_path__ + "img/google-pay-primary-logo-logo-svgrepo-com.eafd25ed.svg";